import React, { useState } from 'react';
import { SearchIcon, SlidersHorizontalIcon, ChevronDownIcon, FilterIcon } from 'lucide-react';
export const SearchFilters = ({
  searchTerm,
  setSearchTerm,
  showFilters,
  setShowFilters,
  selectedGenre,
  setSelectedGenre,
  sortOption,
  setSortOption,
  genres,
  darkMode
}: any) => {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  return <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg p-3 md:p-4 mb-6`} data-id="element-17814" data-mp="2mwjw0wc67205">
      <div className="flex flex-col space-y-3" data-id="element-17815" data-mp="2rubxagypg0h0">
        <div className="flex items-center gap-2" data-id="element-17816" data-mp="2rx7vm6egsr5z">
          <div className="relative flex-1" data-id="element-17817" data-mp="2wty9qo6plcor">
            <SearchIcon className={`absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`} data-id="element-17818" data-mp="2wuzph5yo6nct" />
            <input type="text" placeholder="Search by name or theme..." className={`pl-9 pr-4 py-2 w-full rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-purple-500 ${darkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'border border-gray-300 text-gray-900'}`} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-17819" data-mp="12h8h09s2u9iy" />
          </div>
          <div className="flex items-center gap-1 md:hidden" data-id="element-17820" data-mp="2v5vrnujisxzx">
            <button onClick={() => setMobileFiltersOpen(!mobileFiltersOpen)} className={`p-2 rounded-md ${mobileFiltersOpen ? 'bg-purple-600 text-white' : darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-700'}`} data-id="element-17821" data-mp="2v7ox56iedc6c">
              <FilterIcon className="h-4 w-4" data-id="element-17822" data-mp="3iuey04j0f0pd" />
            </button>
          </div>
        </div>

        {mobileFiltersOpen && <div className="md:hidden space-y-3 pt-1" data-id="element-17823" data-mp="3etlavdde5pxj">
            <div data-id="element-17824" data-mp="27gt09uz33qs8">
              <label className={`block text-xs font-medium mb-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-17825" data-mp="27hcjdf0h0l7u">
                Sort by
              </label>
              <select value={sortOption} onChange={e => setSortOption(e.target.value)} className={`w-full text-sm rounded-md px-3 py-2 ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-gray-50 border border-gray-300 text-gray-900'}`} data-id="element-17826" data-mp="24wwl57js41fs">
                <option value="name" data-id="element-17827" data-mp="1zvgyjb1ydmva">Name</option>
                <option value="price" data-id="element-17828" data-mp="1m5dm1bsvl7j1">Price</option>
                <option value="releaseDate" data-id="element-17829" data-mp="1m4lqg0za39sr">Release Date</option>
              </select>
            </div>
            <div data-id="element-17830" data-mp="1qxn64b7b7dde">
              <label className={`block text-xs font-medium mb-1 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-17831" data-mp="1qy6nnqt1rzqw">
                Genre
              </label>
              <select value={selectedGenre} onChange={e => setSelectedGenre(e.target.value)} className={`w-full text-sm rounded-md px-3 py-2 ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-gray-50 border border-gray-300 text-gray-900'}`} data-id="element-17832" data-mp="1h6k3h4yqeqc0">
                <option value="" data-id="element-17833" data-mp="olnethdoqg50">All Genres</option>
                {genres.map((g: string) => <option key={g} value={g} data-id="element-17834" data-mp="jn2dfemp5qez">
                    {g}
                  </option>)}
              </select>
            </div>
          </div>}

        <div className="hidden md:flex items-center justify-end" data-id="element-17835" data-mp="sk2xj92qh2cm">
          <div className="relative" data-id="element-17836" data-mp="17hvfe7vr62tz">
            <button onClick={() => setShowFilters(!showFilters)} className={`flex items-center px-3 py-2 rounded-md ${darkMode ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-17837" data-mp="17gtwxiceqe28">
              <SlidersHorizontalIcon className="h-4 w-4 mr-2" data-id="element-17838" data-mp="1cag630jd3zta" />
              Filters
              <ChevronDownIcon className={`h-4 w-4 ml-2 transition-transform ${showFilters ? 'rotate-180' : ''}`} data-id="element-17839" data-mp="1q8d3u09jyc9j" />
            </button>
            {showFilters && <div className={`absolute right-0 top-full mt-2 w-56 rounded-md shadow-lg z-10 ${darkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'}`} data-id="element-17840" data-mp="25czbc9taxfvf">
                <div className="p-4 space-y-4" data-id="element-17841" data-mp="2e5suwjfs71f3">
                  <div data-id="element-17842" data-mp="2j3ky49lvm9yl">
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-17843" data-mp="2j443yry957w9">
                      Sort by
                    </label>
                    <select value={sortOption} onChange={e => setSortOption(e.target.value)} className={`w-full rounded-md ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'}`} data-id="element-17844" data-mp="1qfylycyl1x04">
                      <option value="name" data-id="element-17845" data-mp="36snbh59h9gna">Name</option>
                      <option value="price" data-id="element-17846" data-mp="3brqj8xgue0yy">Price</option>
                      <option value="releaseDate" data-id="element-17847" data-mp="3bucqevztmegn">Release Date</option>
                    </select>
                  </div>
                  <div data-id="element-17848" data-mp="v5tljotg374v">
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-17849" data-mp="v5a6cfv6iwuj">
                      Genre
                    </label>
                    <select value={selectedGenre} onChange={e => setSelectedGenre(e.target.value)} className={`w-full rounded-md ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'}`} data-id="element-17850" data-mp="lf8qgbczckqp">
                      <option value="" data-id="element-17851" data-mp="7ghfuyxbth7b">All Genres</option>
                      {genres.map((g: string) => <option key={g} value={g} data-id="element-17852" data-mp="2j8wiv0fz74h">
                          {g}
                        </option>)}
                    </select>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};